import * as React from "react";
import { forwardRef } from "react";
const SvgDoorOpening = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { id: "Livello_2", "data-name": "Livello 2", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 25.34", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "Livello_3", "data-name": "Livello 3" }, /* @__PURE__ */ React.createElement("path", { d: "M24,18.19h-1.98V.25H3.12l-1.11-.25v18.19H0v2h2.77v-.02l.23.05v5.11h3.94v-4.24l6.08,1.35v-2.25h4.07v5.02h3.94v-5.02h.99s1.98-.01,1.98-.01v-2ZM20.02,2.25v15.92h-2.93v.03h-4.07V2.44h-.01v-.2h7.01ZM4.01,2.49l7,1.55v15.91l-7-1.55V2.49Z" })));
const ForwardRef = forwardRef(SvgDoorOpening);
export default ForwardRef;
